import React from 'react';

export default function PredictionLoader({ mobile, count = 2 }) {

  return (
    <div className={`container flex flex-col space-y-4 w-full px-3 mb-4`}>
      {Array.from({ length: count }).map((_, index) => (
        <div key={`prediction-${index}`} className="h-32 flex p-4 rounded-md animate-pulse bg-rand-200 z-1">
          <div className="flex flex-col justify-center ml-2 space-y-2 w-full">
          </div>

        </div>
      ))}
    </div>
  );
}
